module.exports = __webpack_public_path__ + "img/8b26bcd503f74ec7d70043f9b98a9a06.png";